// @owners { team: patients-team }
export enum CategorySearch {
  Search = -2,
  All = -1,
}
